export const REDIRECT_URL = "rdrtUrl";

export const TAAGER_COURSE_URL =
  "https://www.youtube.com/playlist?list=PLmEy_hlZ7kB8IntnGW0wMTod3Udw4MucE";
